module.exports = __webpack_public_path__ + "media/images/icons/load_more-46b593edd00ab01ca1670f90fa2b7365.svg";